
import { createReducer } from 'reducers';
import { Map } from 'immutable'; // use of immutablejs for various js operations to simplify our work
import { createStructuredSelector } from 'reselect';
import {
    REGISTER_SUCCESSFUL,
} from 'containers/Register/RegisterActionTypes';


import {
    LOGIN_SUCCESSFUL,
} from 'containers/Login/LoginActionTypes';

import {
    SESSION_VALID,
    SESSION_LOGOUT,
    SESSION_ATTRIB,
    LOCATION_CHANGE,
} from './SessionActionTypes';

export const initialState = Map({
  session: {},
  user: {},
  isValid: true,
  attributes: Map(),
  userLoggedOut: false,
  time: 0,
});

const handlers = {

  [REGISTER_SUCCESSFUL](state, action) {
    return state.merge({
      session: action.session,
      user: action.user,
    });
  },
  [LOGIN_SUCCESSFUL](state, action) {
    return state.merge({
      session: action.session,
      user: action.user,
    });
  },
  [SESSION_VALID](state, action) {
    return state.merge({
      session: action.session,
      user: action.user,
      isValid: true,
      attributes: action.attributes,
    });
  },
  [SESSION_LOGOUT](state) {
    const date = new Date();
    return state.merge({
      session: {},
      user: {},
      isValid: false,
      time: date.getTime(),
      attributes: Map(),
      userLoggedOut: true,
    });
  },
  [LOCATION_CHANGE](state) {
    const date = new Date();
    return state.merge({
      time: date.getTime(),
    });
  },
  [SESSION_ATTRIB](state, action) {
    return state.merge({
      attributes: action.attributes,
    });
  },
};

export const session = createReducer(initialState, handlers);

// LOGIN SELECTOR
const getSession = state => state.session.get('session');
const getUser = state => state.session.get('user');
const getIsValid = state => state.session.get('isValid');
const getAttributes = state => state.session.get('attributes');
const time = state => state.session.get('time');
const userLoggedOut = state => state.session.get('userLoggedOut');
export const sessionSelector = createStructuredSelector({
  session: getSession,
  user: getUser,
  isValid: getIsValid,
  attributes: getAttributes,
  time,
  userLoggedOut,
});



// WEBPACK FOOTER //
// ./src/components/Session/Session.redux.js